<template>
	<div class="password">
		<input
			name="password-input"
			:class="[alertClass ? 'alert' : '', adminDetail ? 'admin' : '']"
			class="password__input"
			placeholder="*****************"
			:type="fieldType"
			:value="value"
			maxlength="15"
			autocomplete="chrome-off"
			v-on:keyup.enter="emitEnter"
			@input="emitValue($event.target.value)"
		/>
		<div @click="togglePasswordType">
			<EyeClosed v-if="showPassword" class="eye" :class="[adminDetail ? 'admin' : '']" />
			<EyeOpened v-else class="eye" :class="[adminDetail ? 'admin' : '']" />
		</div>
	</div>
</template>

<script>
import EyeOpened from '@/components/shared/Icons/EyeOpened.vue';
import EyeClosed from '@/components/shared/Icons/EyeClosed.vue';

export default {
	name: 'InputPassword',
	components: {
		EyeOpened,
		EyeClosed,
	},
	props: {
		value: {
			type: String,
		},
		adminDetail: {
			default: false,
		},
		alertClass: {
			required: false,
		},
	},
	data: () => ({
		showPassword: false,
	}),
	methods: {
		togglePasswordType() {
			this.showPassword = !this.showPassword;
		},
		emitValue(newValue) {
			this.$emit('input', newValue);

			if (this.alertClass) {
				this.$emit('clearRequired');
			}
		},
		emitEnter() {
			this.$emit('emitEnter');
		},
	},
	computed: {
		fieldType() {
			return this.showPassword ? 'text' : 'password';
		},
	},
};
</script>

<style scoped lang="scss">
@import 'InputPassword.scss';
</style>
